/**
 * Panel lateral de creación y edición (DS 4.8 + 4.8bis).
 *
 * La regla del producto no se decide por cuántos campos tiene el formulario:
 *
 *   - Crear o editar un registro  → `<FormDrawer>` (este archivo).
 *   - Decisión corta que interrumpe (vigencia, confirmar un borrado, un aviso
 *     que exige respuesta) → `<ResponsiveDialog>` / `<VigenciaModal>`.
 *
 * El drawer deja la tabla visible detrás — el contexto de "estoy administrando
 * este listado" — y absorbe campos nuevos sin rediseñar. Por eso vale aunque
 * hoy el formulario tenga dos campos.
 *
 * Es la misma máquina que `ResponsiveDialog` con `desktop="drawer"`: existe
 * como componente propio para que la regla sea legible en el call site y
 * greppable en review. En móvil (<768px) los dos son el mismo drawer inferior
 * de vaul; lo único que cambia es el escritorio.
 */
import * as React from "react";
import {
  ResponsiveDialog,
  ResponsiveDialogBody,
  ResponsiveDialogClose,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogFooter,
  ResponsiveDialogFooterHint,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
  ResponsiveDialogTrigger,
  responsiveDrawerBodyClass,
  type ResponsiveDialogProps,
} from "@/components/ui/ResponsiveDialog";

export type FormDrawerProps = Omit<ResponsiveDialogProps, "desktop">;

export function FormDrawer(props: FormDrawerProps) {
  return <ResponsiveDialog {...props} desktop="drawer" />;
}

export {
  ResponsiveDialogBody as FormDrawerBody,
  ResponsiveDialogClose as FormDrawerClose,
  ResponsiveDialogContent as FormDrawerContent,
  ResponsiveDialogDescription as FormDrawerDescription,
  ResponsiveDialogFooter as FormDrawerFooter,
  ResponsiveDialogFooterHint as FormDrawerFooterHint,
  ResponsiveDialogHeader as FormDrawerHeader,
  ResponsiveDialogTitle as FormDrawerTitle,
  ResponsiveDialogTrigger as FormDrawerTrigger,
  /**
   * Clases del cuerpo para cuando el contenedor scrolleable NO puede ser un div
   * propio — el caso de los formularios, donde el `<form>` tiene que envolver
   * campos Y pie para que el submit siga asociado. Si el cuerpo sí puede ser su
   * propio elemento, usar `<FormDrawerBody>`.
   */
  responsiveDrawerBodyClass as formDrawerBodyClass,
};
